var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRfq = function SvgRfq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 .667a2 2 0 0 0-2 2v10.666a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8a.666.666 0 0 0-.195-.471l-4-4a.667.667 0 0 0-.472-.195H4Zm-.471 1.528A.667.667 0 0 1 4 2h4.667v3.333c0 .368.298.667.666.667h3.334v7.333A.667.667 0 0 1 12 14H4a.667.667 0 0 1-.667-.667V2.667c0-.177.07-.347.196-.472Zm8.195 2.472L10 2.942v1.724h1.724ZM6 9.332a.667.667 0 0 0 0 1.333h4a.667.667 0 0 0 0-1.333H6Z"
  })));
};

export default SvgRfq;